// extracted by mini-css-extract-plugin
module.exports = {"emptyBase":"Empty_emptyBase__rF-fL","icon":"Empty_icon__1SW_D"};